

import axios from 'axios';
import { API_URL } from '../ApiConfig2';

export const AlterSenha = async (Dados) => {
  try {
    const response = await axios.post(`${API_URL}/alterPassword`, Dados);
    return response.data;  
  } catch (error) {
    
    return { success: false, message: error.response.data.message };
  }
};
